// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "../../../../hooks/auth/useTokenAccess";

// Types and API
import { getExternalExamById } from "../../api";
import { IndividualExternalExamType } from "../../types";

export const useExternalExamById = (
  clinicId: string | undefined,
  payload: { patientId: string; examId: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<IndividualExternalExamType>({
    queryKey: ["external-exams", payload.examId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getExternalExamById(
        token,
        clinicId,
        payload.patientId,
        payload.examId,
        controller.signal
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 0, // do not cache so data is always fresh on the reports page
  });
};
